import {WlTextInput} from "../../../common/ts/webcomponents/textInput/textInput.component";
import PageData from "../../../common/ts/PageData";
import UserContactDataStorageService, {
    UserContactDataType
} from "../../../common/ts/services/UserContactDataStorageService";
import {WlChange} from "../../../common/ts/webcomponents/events/WlChange";
import {WlTextInputValidationHandler} from "../../../common/ts/forms/validator/_new/WlTextInputValidationHandler";
import {TextInputValidator} from "../../../common/ts/forms/validator/_new/TextInputValidator";
import {PhoneInputValidator} from "../../../common/ts/forms/validator/_new/PhoneInputValidator";
import {EmailInputValidator} from "../../../common/ts/forms/validator/_new/EmailInputValidator";

export type Contact = {
    name: string,
    phone: string,
    email: string,
    message: string
}

export class WlContactForm {
    private readonly nameInput: WlTextInput;
    private readonly phoneInput: WlTextInput;
    private readonly emailInput: WlTextInput;
    private readonly messageInput: WlTextInput;
    private readonly pageData: PageData;

    private readonly localStorageService: UserContactDataStorageService;
    private readonly emailValidator: WlTextInputValidationHandler;
    private readonly nameValidator: WlTextInputValidationHandler;
    private readonly phoneValidator: WlTextInputValidationHandler;
    private readonly messageValidator: WlTextInputValidationHandler;

    constructor(params: {
        nameInput: WlTextInput,
        phoneInput: WlTextInput,
        emailInput: WlTextInput,
        messageInput: WlTextInput,
        pageData: PageData
    }) {
        ({
            nameInput: this.nameInput,
            phoneInput: this.phoneInput,
            emailInput: this.emailInput,
            messageInput: this.messageInput,
            pageData: this.pageData
        } = params);

        this.localStorageService = new UserContactDataStorageService();
        this.emailValidator = new WlTextInputValidationHandler(
            this.emailInput,
            new EmailInputValidator()
        )
        this.nameValidator = new WlTextInputValidationHandler(
            this.nameInput,
            new TextInputValidator(),
        )
        this.phoneValidator = new WlTextInputValidationHandler(
            this.phoneInput,
            new PhoneInputValidator(),
        );
        this.messageValidator = this.nameValidator = new WlTextInputValidationHandler(
            this.nameInput,
            new TextInputValidator(),
        )
    }

    init() {
        this.registerEvents();
    }

    contact(): Contact {
        return {
            name: this.nameInput.value,
            phone: this.phoneInput.value,
            email: this.emailInput.value,
            message: this.messageInput.value
        }
    }

    public areAllFieldsValid() {
        const nameIsValid = this.nameValidator.validate();
        const emailIsValid = this.emailValidator.validate();
        const phoneIsValid = this.phoneValidator.validate();
        const messageIsValid = this.messageValidator.validate();
        return nameIsValid &&
            emailIsValid &&
            phoneIsValid &&
            messageIsValid;
    }

    preFill() {
        this.localStorageService.fillInputsWithStoredValues(
            {input: this.emailInput, type: UserContactDataType.EMAIL},
            {input: this.nameInput, type: UserContactDataType.NAME},
            {input: this.phoneInput, type: UserContactDataType.PHONE},
        );
    }

    save() {
        this.localStorageService.storeUserInputValue(this.nameInput, UserContactDataType.NAME);
        this.localStorageService.storeUserInputValue(this.emailInput, UserContactDataType.EMAIL);
        this.localStorageService.storeUserInputValue(this.phoneInput, UserContactDataType.PHONE);
    }

    private registerEvents() {
        this.emailInput?.listenToChangeEvent((changeEvent: WlChange) => {
            changeEvent.stopImmediatePropagation()
            this.emailValidator.validate()
        })

        this.nameInput?.listenToChangeEvent((changeEvent: WlChange) => {
            changeEvent.stopImmediatePropagation()
            this.nameValidator.validate()
        })

        this.phoneInput?.listenToChangeEvent((changeEvent: WlChange) => {
            changeEvent.stopImmediatePropagation()
            this.phoneValidator.validate()
        })

        this.messageInput?.listenToChangeEvent((changeEvent: WlChange) => {
            changeEvent.stopImmediatePropagation()
            this.messageValidator.validate()
        })
    }
}